<script>
import ieBooking from '@/views/cargo/v0/Integrated/ieBooking'

export default {
  name: 'CLIEBooking',
  extends: ieBooking,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'CL' // 设置默认值
    }
  }
}
</script>
